import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService,
  IncomeTaxEntity,
  JaarrekeningBalans,
  Onderneming
} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription, take } from "rxjs";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-garantievoorziening',
  templateUrl: './spec-garantievoorziening.component.html',
  styleUrls: ['./spec-garantievoorziening.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiDialogModule,
    SharedUiButtonModule,
    CommonModule
  ]
})
export class SpecGarantievoorzieningComponent implements OnInit, OnDestroy {
  private routerSubscription: Subscription | undefined;
  private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
  private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    public currentAangifte = {} as Aangifte;
    public partnerAangifte = {} as Aangifte;

    public showSpinner = true;
    public focusedElementId: string | null = null;
    public dialogVisible = false;

    public ondernemingFG: FormGroup;
    public specGarantieVoorzieningFG = {} as FormGroup;
    public formStructure: any;
    public ondernemingLength: any

    showDialog() {
        this.dialogVisible = true;
    }

    constructor(private fb: FormBuilder,
                private router: Router,
                public dataService: BokkzIbDataService,
                private dataAlgService: BokkzAlgDataService
    ) {
        this.ondernemingFG = this.fb.group({
            ondernemingen: this.fb.array([]),
        });
        this.specGarantieVoorzieningFG = this.fb.group<JaarrekeningBalans>({
            waardeOpening: null as unknown as number,
            waardeSlot: null as unknown as number,
        });

    }

    //onderneming
    get ondernemingen(): FormArray {
        return this.ondernemingFG.get('ondernemingen') as FormArray;
    }

    createOndernemingFormGroup(onderneming?: Onderneming) {
        return this.dataService.createOndernemingFormGroup(onderneming);
    }

    // specificatie beginstand
    getBeginstandGarantievoorziening(index: number): FormArray {
        const outerGroup = this.ondernemingen.at(index) as FormGroup;
        return outerGroup.get('beginstandGarantievoorziening') as FormArray;
    }

    // addBeginstand(index: number): void {
    //     const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
    //         omschrijving: '',
    //         bedrag: undefined as unknown as number,
    //
    //     });
    //     const outerGroup = this.ondernemingen.at(index) as FormGroup;
    //     const innerArray = outerGroup.get('beginstandGarantievoorziening') as FormArray;
    //     innerArray.push(innerGroup);
    // }
    //
    // deleteBeginstand(outerIndex: number, innerIndex: number): void {
    //     const innerArray = this.getBeginstandGarantievoorziening(outerIndex);
    //     innerArray.removeAt(innerIndex);
    //     const updatedAangifte: Aangifte = {
    //         ...this.aangifte,
    //         box1: {
    //             winstUitOnderneming: {
    //                 ...this.aangifte.box1?.winstUitOnderneming,
    //                 ondernemingen: this.ondernemingFG.value.ondernemingen
    //             }
    //         }
    //     } as Aangifte;
    //     this.dataService.updateAangifte(updatedAangifte);
    // }
    //
    // createBeginstandFG(item?: OmschrijvingEnBedrag): FormGroup {
    //     return this.fb.group<OmschrijvingEnBedrag>({
    //         omschrijving: item ? item.omschrijving : null as unknown as string,
    //         bedrag: item ? item.bedrag : null as unknown as number,
    //     });
    // }

    getTotaal(): number {
        const start = this.specGarantieVoorzieningFG.get('waardeOpening')?.value || 0
        const dotatie = 0
        const onttrekking = 0
        const einde = this.specGarantieVoorzieningFG.get('waardeSlot')?.value || 0
        const result = start + dotatie - onttrekking - einde;
        return Math.abs(result);
    }

    getTotaalOpening(index: number): number {
        const beginstandKERArray = this.getBeginstandGarantievoorziening(index).controls;
        let totaal = 0;

        for (const control of beginstandKERArray) {
            const bedrag = control.get('bedrag')?.value || 0;
            if (typeof bedrag === 'number') {
                totaal += bedrag;
            }
        }
        return totaal;
    }

    getVerschilOpening(): number {
        const totaalSpec = this.getTotaalOpening(0) || 0;
        const start = this.specGarantieVoorzieningFG.get('waardeOpening')?.value || 0;
        const result = totaalSpec - start;
        return Math.abs(result);
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm();
                this.partner.subscribe((boolean) => {
                    this.partnerBoolean = boolean;
                    this.ondernemingFG.reset()
                    this.specGarantieVoorzieningFG.reset()
                    this.updateForm();
                });
                this.ondernemingFG.valueChanges.subscribe(value => {
                    this.formStructure = value;
                });
                this.ondernemingen.valueChanges.subscribe(value => {
                    this.ondernemingLength = value
                })
                if (this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0].voorzieningen?.at(1)) {
                    this.specGarantieVoorzieningFG.patchValue(this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0].voorzieningen[0], {emitEvent: false});
                }
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter(
            (event: Event): event is NavigationEnd =>
              event instanceof NavigationEnd,
          ),
        )
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.ondernemingFG.dirty || this.specGarantieVoorzieningFG.dirty
  }
    private updateForm(): void {
        let ondernemingenLijst = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                ondernemingenLijst = this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen || [];
            }
        });
        const formArray = this.ondernemingFG.get('ondernemingen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > ondernemingenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update ondernemingen
        for (let i = 0; i < ondernemingenLijst.length; i++) {
            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(ondernemingenLijst[i]);
            } else {
                const formGroup = this.createOndernemingFormGroup(ondernemingenLijst[i])
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }

        let balansItem = {} as JaarrekeningBalans
        if (this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0].voorzieningen?.at(0)) {
            balansItem = this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen[0].voorzieningen?.at(0) as JaarrekeningBalans;
        }
        this.specGarantieVoorzieningFG.patchValue(balansItem);
        this.getTotaal()
    }

    saveForm(): void {
      this.partner.pipe(take(1)).subscribe((partner) => {
        const ondernemingen = !partner
          ? this.incomeTaxEntity.aangifte?.box1?.winstUitOnderneming?.ondernemingen
          : this.incomeTaxEntity.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen;
        if (ondernemingen) {
          const voorzieningen = ondernemingen[0]?.voorzieningen?.find(item => item.omschrijving === 'garantieVoorziening');
          if (voorzieningen) {
            Object.assign(voorzieningen, this.specGarantieVoorzieningFG.getRawValue());
          }

          this.incomeTaxEntity.aangifte = {
            ...this.incomeTaxEntity.aangifte,
            ...(partner &&
              { partnerAangifte:
                  { ...this.incomeTaxEntity.aangifte?.partnerAangifte } }),
          } as Aangifte;

          this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
      });
    }

  public heeftOndernemingen(): boolean {
    if (this.partnerBoolean) {
      return !!(this.incomeTaxEntity &&
        this.incomeTaxEntity.aangifte?.partnerAangifte &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1 &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen &&
        this.incomeTaxEntity.aangifte?.partnerAangifte.box1.winstUitOnderneming.ondernemingen.length > 0);
    } else {
      return !!(this.incomeTaxEntity.aangifte &&
        this.incomeTaxEntity.aangifte?.box1 &&
        this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming &&
        this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen &&
        this.incomeTaxEntity.aangifte?.box1.winstUitOnderneming.ondernemingen.length > 0);
    }
  }
}


